import { useMemo } from 'react';

import {
	usePetitionDetailsPageData,
	usePetitionDetailsPageUserData,
} from 'src/app/pages/petitionGamma/details/pageContext';
import type { DecisionMaker } from 'src/app/pages/petitionGamma/details/shared/types';

type Result = ModelHookResult<{
	showLegislativeBodies: boolean;
}>;

export function useDecisionMakerSection(): Result {
	const {
		data: {
			petition: {
				primaryDecisionMakerConnection: { nodes: allDms },
			},
		},
	} = usePetitionDetailsPageData();

	const {
		data: { isUserEligibleForLegislativeBodies },
	} = usePetitionDetailsPageUserData();
	const showLegislativeBodies = useMemo(() => {
		return legislativeBodiesPresent(allDms) ? isUserEligibleForLegislativeBodies : false;
	}, [allDms, isUserEligibleForLegislativeBodies]);

	return {
		data: {
			showLegislativeBodies,
		},
	};
}

const legislativeBodiesPresent = (dms: readonly DecisionMaker[]) => {
	// counts dms that can be grouped.
	// returns true if there's at least one group
	const lbNames = new Set();

	for (const dm of dms) {
		const { title, type } = dm;
		if (type === 'POLITICIAN' && title) {
			const lb = title.split(' - ')[0].trim();
			if (lbNames.has(lb)) return true;
			lbNames.add(lb);
		}
	}
	return false;
};
